import { render, staticRenderFns } from "./Etapa3.vue?vue&type=template&id=20b4502a&scoped=true&"
import script from "./etapa3.ts?vue&type=script&lang=ts&"
export * from "./etapa3.ts?vue&type=script&lang=ts&"
import style0 from "./Etapa3.vue?vue&type=style&index=0&id=20b4502a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b4502a",
  null
  
)

export default component.exports